// React
import React from 'react';

// Componentes
import HomePage from '../../pages/HomePage/HomePage';
import NavigationBar from '../../components/NavigationBar/NavigationBar';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import DadosEmpresaPage from '../../pages/DadosEmpresaPage/DadosEmpresaPage';
import InformacoesComplementaresPage from '../../pages/InformacoesComplementaresPage/InformacoesComplementaresPage';
import ElegibilidadePage from '../../pages/ElegibilidadePage/ElegibilidadePage';
import SelecaoPlanoElegibilidadePage from '../../pages/SelecaoPlanoElegibilidadePage/SelecaoPlanoElegibilidadePage';
import DistribuicaoFaixasElegibilidadePage from '../../pages/DistribuicaoFaixasElegibilidadePage/DistribuicaoFaixasElegibilidadePage';
import GerarPropostaPage from '../../pages/GerarPropostaPage/GerarPropostaPage';
import ImpressaoPropostaPage from '../../pages/ImpressaoPropostaPage/ImpressaoPropostaPage';
import SemAcessoPage from '../../pages/SemAcessoPage/SemAcessoPage';
import FinalizacaoOportunidadePage from '../../pages/FinalizacaoOportunidadePage/FinalizacaoOportunidadePage';
import InformacoesNivel2Page from '../../pages/InformacoesNivel2Page/InformacoesNivel2Page';
import ReembolsoNivel2Page from '../../pages/ReembolsoNivel2Page/ReembolsoNivel2Page';
const componentMapping = {
  HomePage,
  NavigationBar,
  Breadcrumbs,
  DadosEmpresaPage,
  InformacoesComplementaresPage,
  ElegibilidadePage,
  SelecaoPlanoElegibilidadePage,
  DistribuicaoFaixasElegibilidadePage,
  GerarPropostaPage,
  InformacoesNivel2Page,
  ReembolsoNivel2Page,
  ImpressaoPropostaPage,
  SemAcessoPage,
  FinalizacaoOportunidadePage
};

const ComponentRender = ({ Render }) => {

  return (
    <div>
      {Render.map((componentName, index) => {
        const Component = componentMapping[componentName];
        return <Component key={index}/>;
      })}
    </div>
  );
};

export default ComponentRender;